import axios from "axios";
import {apiUri} from "../../../config";

export const FETCH_FIRM_SETTING_ATTEMPT = 'FETCH_FIRM_SETTING_ATTEMPT';
export const FETCH_FIRM_SETTING_SUCCESS = 'FETCH_FIRM_SETTING_SUCCESS';
export const FETCH_FIRM_SETTING_FAILURE = 'FETCH_FIRM_SETTING_FAILURE';


export const fetch_firm_settings = () => {
	return (dispatch) => {
		dispatch({type: FETCH_FIRM_SETTING_ATTEMPT});
		axios.get(apiUri + "/firms/settings")
			.then(json => {
				const response = json.data.content;
				dispatch({
					type: FETCH_FIRM_SETTING_SUCCESS,
					data: response,
				})
			})
			.catch(err => {
				dispatch({type: FETCH_FIRM_SETTING_FAILURE, error: err})
			})
	}
};


// WEBPACK FOOTER //
// ./src/settings/firm/redux/actions.js